<style lang="less">
  @import "./login.less";

</style>

<template>
  <div class="login" @keydown.enter="handleSubmit">
    <div class="login-con">
      <Card :bordered="false">
        <p slot="title">
          <Icon type="md-log-in"></Icon>欢迎登录123
        </p>
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="rules">
            <FormItem prop="userName">
              <i-input v-model="form.userName" placeholder="请输入用户名" autocomplete="off">
                <span slot="prepend">
                  <Icon :size="16" type="md-person"></Icon>
                </span>
              </i-input>
            </FormItem>
            <FormItem prop="password">
              <i-input type="password" v-model="form.password" placeholder="请输入密码" autocomplete="off">
                <span slot="prepend">
                  <Icon :size="16" type="md-lock"></Icon>
                </span>
              </i-input>
            </FormItem>
            <FormItem>
              <SecurityCode :value.sync="value" :biyiCaptchaKey.sync="biyiCaptchaKey" width="260" ref="securityCode">
              </SecurityCode>
            </FormItem>
            <FormItem v-if="Setting.isCas">
              <Select v-model="casOrNormal" transfer @on-change='goToCas'>
                <Option value="normal">普通登录</Option>
                <Option value="cas">cas登录</Option>
              </Select>
            </FormItem>
          </Form>
          <Button @click="handleSubmit" type="primary" long :loading="isLogining">
            {{loginBtnText}}
          </Button>
          <div style="margin-top:5px;font-size: 0.625rem;">
            <Checkbox style="marign-top:30px;" v-model="rememberme" @on-change="setRememberMe">记住我</Checkbox>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
  import { SecurityCode } from 'biyi-captcha'
  import { format } from "url"
  export default {
    props:{
      Setting:{
        type:Object,
        default:{
          isCas:false
        }
      },
      cas:Object
    },
    data() {
      return {
        isLogining: false,
        loginBtnText: '登录',
        rememberme: null,
        form: {
          userName: '',
          password: ''
        },
        rules: {
          userName: [{
            required: true,
            message: '账号不能为空',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }]
        },
        value: '',
        biyiCaptchaKey: '',
        casOrNormal: 'normal'
      }
    },
    components: {
      SecurityCode
    },
    methods: {
      setRememberMe(value) {
        if (value) {
          localStorage['rememberme'] = 1
        } else {
          localStorage['rememberme'] = 0
        }
      },
      handleSubmit() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.isShowModal = true
            this.isLogining = true
            let msg = this.$Message.loading({
              content: '正在登录中',
              duration: 0
            })
            var pswd = this.$util.encryptPassword ? this.$util.encryptPassword(this.form.password) : this.form.password
            const [url, data, config] = [
              '/api/system/login',
              {
                username: this.form.userName,
                password: pswd,
                rememberme: localStorage['rememberme']
              },
              {
                headers: {
                  biyiCaptchaKey: this.biyiCaptchaKey,
                  biyiCaptcha: JSON.stringify({
                    code: this.value
                  })
                }
              }
            ]
            this.$http.post(url, data, config).then(response => {
              msg()
              if (this.$route.meta.validatePaswd && response.data.passwordStatus) {
                this.isLogining = false
                this.$Message.warning({
                  content: response.data.passwordStatus === 1 ? '初始密码强度较弱，请修改后再重新登录！' :
                    '密码已使用3个月，请修改后再重新登录！'
                })
                this.$router.push({  name: 'update-password' })
              } else {
                localStorage.token = response.data.token
                this.$Message.success({
                  content: '登录成功！',
                  onClose: () => {
                    this.$router.push('/')
                  }
                })
              }
            }).catch(error => {
              msg()
              this.$refs.securityCode.init()
              this.isLogining = false
              if (error.response) {
                switch (error.response.status) {
                  case 401:
                    if (error.response.data.attempts) {
                      this.$Message.error(`登录失败，您还有 ${error.response.data.attempts} 尝试机会！`)
                    } else {
                      const locktime = this.formatLockedTime(error.response.data.lockoutTime)
                      this.$Message.error({
                        content: `登录失败，您的账号已被锁定，请在<span style="font-weight: bold; color: #2d8cf0;">${locktime}</span>后重试！`
                      })
                    }
                    break
                  default:
                    this.$Message.error(`登录失败，${error.response.data.message}！`)
                    break
                }
              }
            })
          }
        })
      },
      formatLockedTime (time) {
        let str = ''
        const d = parseInt(time / (3600 * 24))
        let h = parseInt((time % (3600 * 24)) / 3600)
        let m = parseInt((time % 3600) / 60)
        let s = ((time % 3600) % 60)
        if (d > 0) {
          str = `${str}${d}天`
        }
        if (h > 0) {
          str = `${str}${h}小时`
        }
        if (m > 0) {
          str = `${str}${m}分`
        }
        if (s > 0) {
          str = `${str}${s}秒`
        }
        return str
      },
      goToCas (value) {
        if(value == 'cas'){
          this.cas.login()
        }
      }
    },
    created () {
      this.$store.commit('user/logout')
      if (!localStorage['rememberme']) {
        localStorage['rememberme'] = 0
      }
      this.rememberme = !(localStorage['rememberme'] === '0')
    }
  }

</script>

<style lang="less">
  .replacement {
    position: absolute;
    opacity: 0;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

</style>
